import React from 'react';
import { motion } from 'framer-motion';
import { CheckItem } from './CheckItem';
import { CTAButton } from './CTAButton';
export function IdentificationSection() {
  return <section className="w-full bg-navy-dark py-10 md:py-14" data-id="element-121">
      <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-122">
        {/* Personal story */}
        <motion.div initial={{
        opacity: 0,
        y: 30
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6
      }} className="text-center mb-8" data-id="element-123">
          <p className="text-lg text-cream-muted leading-relaxed mb-4" data-id="element-124">
            Yo también pensé que tenía un problema para dormir…
          </p>
          <p className="text-lg text-cream-muted leading-relaxed mb-4" data-id="element-125">
            hasta que entendí que no era el sueño…
          </p>
          <p className="font-playfair text-2xl md:text-3xl font-bold text-amber" data-id="element-126">
            era mi cuerpo.
          </p>
        </motion.div>

        {/* Physical symptoms - new block */}
        <motion.div initial={{
        opacity: 0,
        y: 30
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6,
        delay: 0.1
      }} className="text-center mb-10 space-y-4 text-lg text-cream-muted leading-relaxed max-w-2xl mx-auto" data-id="element-127">
          <p data-id="element-128">Y con el paso de los días… tu cuerpo empieza a cambiar.</p>
          <p data-id="element-129">Amaneces con mal humor… sin energía… con la mente pesada.</p>
          <p data-id="element-130">
            Aparecen las ojeras… la inflamación… esa sensación de cansancio que
            no se va.
          </p>
          <p data-id="element-131">
            Empiezas a sentirte más pesada… como si tu cuerpo estuviera fuera de
            equilibrio.
          </p>
          <p data-id="element-132">
            Incluso puedes notar pérdida de masa muscular… o acumulación de
            grasa… sin entender por qué.
          </p>
          <p className="text-cream font-medium" data-id="element-133">
            Y no… no es solo por no dormir bien.
          </p>
          <p data-id="element-134">Es porque tu cuerpo está desregulado…</p>
          <p className="text-amber font-medium" data-id="element-135">
            y tu sistema hormonal está respondiendo a ese estado constante de
            alerta.
          </p>
        </motion.div>

        {/* Y aquí es donde todo cambia - replaces old "Por eso creé" */}
        <motion.div initial={{
        opacity: 0,
        y: 30
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6,
        delay: 0.2
      }} className="text-center mb-8 space-y-4 text-lg text-cream-muted leading-relaxed max-w-2xl mx-auto" data-id="element-136">
          <p className="text-xl text-amber font-medium" data-id="element-137">
            Y aquí es donde todo cambia…
          </p>
          <p data-id="element-138">
            Porque cuando entiendes lo que realmente está pasando en tu cuerpo…
            dejas de luchar contra el sueño…
          </p>
          <p className="text-cream" data-id="element-139">y empiezas a recuperar el control.</p>
          <p data-id="element-140">
            No necesitas más fuerza de voluntad… ni intentar dormir "mejor"…
          </p>
          <p className="text-cream font-medium" data-id="element-141">
            necesitas enseñarle a tu cuerpo cómo salir de ese estado de alerta.
          </p>
          <p className="font-playfair text-2xl md:text-3xl font-bold text-amber mt-4" data-id="element-142">
            Por eso creé el Método de 21 Noches.
          </p>
          <p data-id="element-143">
            Un proceso simple que te guía paso a paso para regular tu sistema
            nervioso…
          </p>
          <p data-id="element-144">
            y volver a dormir de forma natural… sin pastillas… sin forzarte…
          </p>
          <p className="text-cream font-medium" data-id="element-145">
            solo entendiendo lo que tu cuerpo necesita.
          </p>
        </motion.div>

        {/* New title + CheckItems */}
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6,
        delay: 0.25
      }} className="text-center mb-6" data-id="element-146">
          <h2 className="font-playfair text-2xl md:text-3xl font-bold text-cream" data-id="element-147">
            Esto es lo que vas a empezar a cambiar desde la primera noche
          </h2>
        </motion.div>

        <div className="space-y-4 mb-10 max-w-md mx-auto" data-id="element-148">
          <CheckItem delay={0.1} data-id="element-149">Calmar tu sistema nervioso</CheckItem>
          <CheckItem delay={0.15} data-id="element-150">Salir del estado de alerta</CheckItem>
          <CheckItem delay={0.2} data-id="element-151">Volver a dormir de forma natural</CheckItem>
        </div>

        {/* Product mockup - moved above CTA */}
        <motion.div initial={{
        opacity: 0,
        scale: 0.95
      }} whileInView={{
        opacity: 1,
        scale: 1
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.8
      }} className="flex justify-center mb-10" data-id="element-152">
          <img src="https://cdn.magicpatterns.com/uploads/rNSfD331Xdw6MhNw7gJo5N/EL_METODO_DE_21_NOCHES_(1).png" alt="Método de 21 Noches — vista completa del producto" className="w-full max-w-lg object-contain drop-shadow-2xl" data-id="element-153" />
        </motion.div>

        {/* CTA Button */}
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.5,
        delay: 0.3
      }} className="flex justify-center" data-id="element-154">
          <CTAButton className="w-full sm:w-auto" data-id="element-155">
            QUIERO DORMIR SIN DESPERTARME
          </CTAButton>
        </motion.div>
      </div>
    </section>;
}